import { type KudoContentObjectDetail, type UploadedFile, createKudoContentObjectDetail } from 'models';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { createKudo } from '../../services';
import { useContentObjectCache } from '../cache';

type CreateKudoData = {
  attachments?: UploadedFile[];
  communityId: string;
  htmlContent: string;
  pinned?: boolean;
  textContent: string;
  userId: string;
};

const defaultErrorHandler = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. Please, try again.');
};

export const useCreateKudoMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<KudoContentObjectDetail, CreateKudoData>({
    defaultMutateOnError: defaultErrorHandler,
    async mutationFn({ attachments, communityId, htmlContent, pinned, textContent, userId }) {
      const response = await createKudo({
        body: {
          kudo: {
            attachments: attachments?.map((attachment) => ({ id: attachment.id })),
            community_id: communityId,
            html_content: htmlContent,
            pinned,
            text_content: textContent,
            user_id: userId,
          },
        },
      });

      return createKudoContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
